<div style="min-height: 200px;">

</div>
<mat-card class="list-small-container">
    <mat-card-header>
        <div fxLayoutAlign="center center"
            style="display:flex;gap:20px;align-items:center;margin-bottom:10px;">
            <div class="form-group">
                <span class="fa fa-search form-control-icon"></span>
                <mat-icon style="color:#aaa;">search</mat-icon>
                <input [formControl]="filter" class="form-control search-input" type="text" placeholder="Szukaj...">
            </div>
        </div>
    </mat-card-header>
    <mat-card-content>
        <mat-chip-listbox selectable multiple>
            <mat-chip-option (click)="toggleSelected(item)" [disabled]="checkDisabled(item)"  [selected]="verifySelected(item)" multiselect *ngFor="let item of filteredRekbots$ | async" >{{item.serial_no}}</mat-chip-option>
        </mat-chip-listbox>
    </mat-card-content>
</mat-card>

